export default "__VITE_ASSET__B_mCh7H1__"